import { TOccupation } from '@interlayer/js/app/components/main/Registration/components/fields/OccupationField/types';

export const parseOccupationsList = (data = '') => {
    const tmp = document.createElement('div');
    tmp.innerHTML = data;

    return tmp.textContent
        ?.replace(/[\n\t]/g, '')
        .split(';')
        .reduce((acc: TOccupation[], item) => {
            const [suggestion, tags = ''] = item.split('###');
            const tagsList = tags.split(',')
                .map((tag) => tag.trim())
                .filter(Boolean);

            acc.push({
                suggestion: suggestion.trim(),
                ...tagsList.length && { tagsList }
            });

            return acc;
        }, []);
};
